import { initializeApp } from 'firebase/app';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration - hardcoded with unrestricted API key
const firebaseConfig = {
  apiKey: "AIzaSyBAZYr30ozT3pW0yRmPrVpMWOWzJrqub6Q",
  authDomain: "aest-966b6.firebaseapp.com",
  projectId: "aest-966b6",
  storageBucket: "aest-966b6.appspot.com",
  messagingSenderId: "1234567890",  // Replace with actual if you have it
  appId: "1:1234567890:web:1234567890"  // Replace with actual if you have it
};

console.log('Firebase Configuration:', {
  projectId: firebaseConfig.projectId,
  authDomain: firebaseConfig.authDomain,
  apiKey: firebaseConfig.apiKey ? 'Key provided (hidden for security)' : 'Missing API key'
});

// Initialize Firebase
console.log('Initializing Firebase app...');
const app = initializeApp(firebaseConfig);
console.log('Firebase app initialized successfully');

// Initialize Firestore
console.log('Initializing Firestore...');
const db = getFirestore(app);
console.log('Firestore initialized successfully');

// Initialize Storage
console.log('Initializing Storage...');
const storage = getStorage(app);
console.log('Storage initialized successfully');

// Enable offline persistence
try {
  enableIndexedDbPersistence(db)
    .then(() => {
      console.log('Firestore persistence has been enabled.');
    })
    .catch((error) => {
      console.warn('Error enabling Firestore persistence:', error.code, error.message);
    });
} catch (error) {
  console.error('Error enabling Firestore persistence:', error);
}

export { db, storage };
